
export function applyFormFixes()
{
    $(".wpforms-form").each(function () {

        $(this).find("input, textarea").each(function () {
            $(this).attr("placeholder", " ");
        });


        $(this).find('.wpforms-field-radio').each(function () {
          // Prepend the label.
            $(this).find('> label').prependTo(this);

          // Adds the radiobutton stylable element.
            $(this).find('> ul > li').each(function () {
                $(this).addClass('container')
                $(this).attr('style', 'position: relative !important;');
                $(this).append("<span class='checkmark'></span>")
            })
        })

        $(this).find('.wpforms-field-checkbox').each(function () {
          // Prepend the label.
            $(this).find('> label').prependTo(this);

          // Adds the checkbox stylable element.
            $(this).find('> ul > li').each(function () {
              // Adds the radio button styling.
                $(this).addClass('container')
                $(this).attr('style', 'position: relative !important;');
                $(this).append("<span class='checkmark-box'></span>")
            })
        })
    });
}
